var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMybeeSystemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 650.736,
    height: 121.732,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3430.01 641.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1{fill:#033841}.fil0{fill:#13be90}.fil2,.fil3{fill:#033841;fill-rule:nonzero}.fil3{fill:#13be90}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1807521352240"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M467.73 210.57H351.28v39.42h39.97v-.13h65.18l32.52 56.49h.14l32.52 56.37-32.66 56.5-32.52 56.37h-65.18v.14l-65.05-.14-16.9-28.35-9.27 10.99-17.91 21.08L303.46 515h175.57l5.79-9.92 38.17-66.29 38.31-66.29 5.65-9.64-5.65-9.79-38.31-66.29v-.14l-38.17-66.28-5.65-9.65zM257.5 210.57H87.92l-5.78 9.92-38.18 66.29-38.31 66.29L0 362.72l5.65 9.78 38.31 66.29v.14l38.18 66.28 5.65 9.79h128.76l23.74-39.41h-64.58v.14l-65.19-.14L78 419.22h-.14l-32.52-56.5L78 306.35l32.52-56.36h65.19v-.13h70.36l22.73-39.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M406.82 182.6H160.14l22.73-39.28 33.49-58.15-21.08-78.42L220.5 0l22.87 85.17H323.58L346.32 0l25.35 6.75-21.08 78.42 33.49 58.15zM162.89 549.03h241.17l-17.09 29.5H179.84zM196.93 608.16h173.09l-19.43 33.48H216.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m218.71 376.46 61.28-1.64L200.65 515h15.9c21.04-23.25 40.97-47.21 61.28-71.11l36.66-43.46 52.17-62.47-59.14-.06 89.49-127.3-93.55-.03-84.75 165.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M938.61 336.52v141.65h63.12v-156.1c0-52.52-30.35-77.09-71.79-77.09-31.8 0-58.3 16.38-70.82 37.1-11.56-25.05-34.69-37.1-63.6-37.1-28.91 0-50.59 14.45-63.6 32.28l-2.89-27.46h-59.74v228.37h63.12V329.29c7.71-15.42 22.64-27.46 40.47-27.46 15.42 0 30.83 10.6 30.83 34.69v141.65h63.12V329.29c7.71-15.42 22.64-27.46 40.47-27.46 15.9 0 31.32 10.6 31.32 34.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    className: "fil2",
    d: "M1076.06 567.3h60.7l124.79-317.5h-65.05l-55.88 148.39-60.71-148.39h-67.45l100.21 223.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    className: "fil2",
    d: "M1275.17 478.17h50.11l4.33-20.72c15.42 16.38 39.99 27.94 65.04 27.94h3.85c49.63 0 98.77-39.51 98.77-111.3v-20.23c0-67.93-38.54-109.85-94.91-109.85h-2.41c-22.65 0-46.73 10.12-61.19 25.05V149.09h-63.6v329.07zm63.12-80.94v-65.52c9.15-18.31 26.98-31.32 44.81-31.32h3.37c23.61 0 46.73 17.83 46.73 54.92v18.31c0 32.76-19.75 54.93-46.73 54.93h-2.89c-13.49 0-34.21-8.19-45.29-31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    className: "fil2",
    d: "M1635.69 484.92c26.02 0 53.48-6.26 68.9-14.94v-51.07c-18.79 7.71-38.06 12.53-61.67 12.53-37.1.48-61.67-15.42-66.97-42.88h148.88v-28.91c0-70.82-35.17-116.11-103.59-116.11-61.67 0-110.33 42.4-110.33 108.4v16.86c0 72.27 48.66 116.11 124.79 116.11zm-61.67-137.31c.96-30.35 19.75-49.63 47.7-49.63 28.43 0 45.29 18.31 45.29 42.88v6.75h-92.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4",
    className: "fil2",
    d: "M1863.23 484.92c26.02 0 53.48-6.26 68.9-14.94v-51.07c-18.79 7.71-38.06 12.53-61.67 12.53-37.1.48-61.67-15.42-66.97-42.88h148.88v-28.91c0-70.82-35.17-116.11-103.59-116.11-61.67 0-110.33 42.4-110.33 108.4v16.86c0 72.27 48.66 116.11 124.79 116.11zm-61.67-137.31c.96-30.35 19.75-49.63 47.7-49.63 28.43 0 45.29 18.31 45.29 42.88v6.75h-92.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5",
    className: "fil2",
    d: "M2005.98 482.51c20.72 0 38.06-16.86 38.06-38.06 0-21.2-17.34-38.54-38.06-38.54-21.2 0-38.06 17.34-38.06 38.54s16.86 38.06 38.06 38.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_6",
    className: "fil3",
    d: "M2152.1 484.43c61.67 0 91.54-32.76 91.54-73.23v-1.44c0-31.8-16.86-54.93-64.08-68.9l-30.35-8.67c-14.94-5.3-24.09-11.56-24.09-20.24v-1.93c0-10.12 14.46-15.42 32.76-15.42 24.09 0 49.14 7.23 72.75 14.94l-.48-50.11c-15.9-8.19-43.84-15.9-74.68-15.9-56.37 0-95.88 23.61-95.88 65.04v1.93c0 35.17 20.24 56.85 67.93 71.79l28.91 9.15c16.86 5.78 23.61 10.6 23.61 20.72v.96c0 12.53-11.08 19.75-33.24 19.75-26.5 0-53.48-5.3-85.28-15.9v53c16.38 4.82 48.66 14.45 90.58 14.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_7",
    className: "fil3",
    d: "M2306.89 567.3h60.7l124.79-317.5h-65.04l-55.89 148.39-60.71-148.39h-67.45l100.21 223.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8",
    className: "fil3",
    d: "M2589.84 484.43c61.67 0 91.54-32.76 91.54-73.23v-1.44c0-31.8-16.86-54.93-64.08-68.9l-30.35-8.67c-14.94-5.3-24.09-11.56-24.09-20.24v-1.93c0-10.12 14.45-15.42 32.76-15.42 24.09 0 49.14 7.23 72.75 14.94l-.48-50.11c-15.9-8.19-43.84-15.9-74.68-15.9-56.37 0-95.88 23.61-95.88 65.04v1.93c0 35.17 20.24 56.85 67.93 71.79l28.91 9.15c16.86 5.78 23.61 10.6 23.61 20.72v.96c0 12.53-11.08 19.75-33.24 19.75-26.5 0-53.48-5.3-85.28-15.9v53c16.38 4.82 48.66 14.45 90.58 14.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_9",
    className: "fil3",
    d: "M2813.52 426.62c-18.31 0-34.21-8.67-34.21-30.35v-92.99h63.12V249.8h-63.12v-66.97l-62.63 10.6v56.37h-26.02v53h26.02v108.4c0 50.11 36.62 74.68 81.9 74.68 17.34 0 36.62-3.85 46.73-10.6v-55.89c-7.71 3.85-18.79 7.23-31.8 7.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_10",
    className: "fil3",
    d: "M2986.14 484.92c26.02 0 53.48-6.26 68.9-14.94v-51.07c-18.79 7.71-38.06 12.53-61.67 12.53-37.1.48-61.67-15.42-66.97-42.88h148.88v-28.91c0-70.82-35.17-116.11-103.59-116.11-61.67 0-110.33 42.4-110.33 108.4v16.86c0 72.27 48.66 116.11 124.79 116.11zm-61.67-137.31c.96-30.35 19.75-49.63 47.7-49.63 28.43 0 45.29 18.31 45.29 42.88v6.75h-92.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_11",
    className: "fil3",
    d: "M3366.9 336.52v141.65h63.12v-156.1c0-52.52-30.35-77.09-71.79-77.09-31.8 0-58.3 16.38-70.82 37.1-11.56-25.05-34.69-37.1-63.6-37.1-28.91 0-50.59 14.45-63.6 32.28l-2.89-27.46h-59.74v228.37h63.11V329.29c7.71-15.42 22.65-27.46 40.47-27.46 15.42 0 30.84 10.6 30.84 34.69v141.65h63.11V329.29c7.71-15.42 22.65-27.46 40.47-27.46 15.9 0 31.32 10.6 31.32 34.69z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybeeSystemLogo);
export default __webpack_public_path__ + "static/media/MYBEE_SYSTEM_LOGO.3c0a067576f34a0665a1fad28467cb95.svg";
export { ForwardRef as ReactComponent };